<template>
  <div class="m-0 dbozone-font bg-woe" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-woe">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("woe.name") }}
          </h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1" v-for="(text, index) in textList" :key="index" >
        <div v-if="index===1">
          <div v-if="lang==='zh'" class="">
            <span class="m-0 text-sub" :class="`-${lang}`">
              {{ $t(`${text}_1`) + betLevel[0] + $t('info.to') + betLevel[betLevel.length-1] + $t(`${text}_2`) + betSize[0] + $t('info.to') + betSize[betSize.length-1] }}
            </span>
          </div>
          <div v-else class="">
            <span class="m-0 text-sub" :class="`-${lang}`">
              {{ $t(`${text}_1`) + betLevel[0] + $t('info.to') + betLevel[betLevel.length-1] + $t(`${text}_2`) + betSize[0] + $t('info.to') + betSize[betSize.length-1] }}
            </span>
          </div>
        </div>
        <div v-else>
          <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>
      <div class="d-flex flex-column nav-woe">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t('main-game.title') }}
          </h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/main/wallet_icon.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.wallet-balance")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-wallet")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/woe/bet_amount_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.bet-amount")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-bet1")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-bet2")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-bet3")
        }}</span>
      </div>

      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/woe/win_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.win-amount")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-win-amount")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/woe/spin_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.spin")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-spin1")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-spin2")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-spin3")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-spin4")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/woe/autospin_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.autospin")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-auto1")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-auto2")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/woe/stop_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.stop")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-stop")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/woe/plus_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.plus")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-plus")
        }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/woe/minus_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.minus")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-minus")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/woe/menu_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.menu")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-menu")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/woe/turbo_on.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.turbo")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-turbo")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/woe/turbo_off.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.normal-turbo")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-normal-turbo")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/woe/quit_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.quit")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-quit")
        }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/woe/info_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.pay-info")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-info")
        }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/woe/paytable_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.info-paytable")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-paytable")
        }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/woe/history_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.history")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-history")
        }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/woe/option_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.setting")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-setting")
        }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info"
          :src="require(`../../assets/ruleGames/woe/close_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.close")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-close")
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "rule-woe",
  props: {
    data: Object,
    lang: String,
  },
  data() {
    return {
      textList: [
        "woe.text-rule1",
        "1_3_base.text-rule2",
        "1_3_base.text-rule3",
        "1_3_base.text-rule4",
        "1_3_base.text-rule5",
        "1_3_base.text-rule6",
        "1_3_base.text-rule7",
        "1_3_base.text-rule8",
        "1_3_base.text-rule9",
        "1_3_base.text-rule10",
        "1_3_base.text-rule11",
        "1_3_base.text-rule12",
        "woe.text-rule13",
        "1_3_base.text-rule14",
        "1_3_base.text-rule15",
      ],
      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
    };
  },
};
</script>

<style>

.bg-woe {
  background: #502201;
}

.nav-woe {
  background: #F1B900;
  border-radius: 10px;
}
</style>